import React, { Component } from 'react';
import { Image } from 'react-native';

import { StyleSheet, View } from 'react-native';

export default class AppCover extends Component {

  render() {
    return (
      <View style={styles.cover}>
        <Image source={require('../../assets/img/coronastop_logo.png')} style={styles.logo} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  logo: {
    height: 115,
    width: 140
  },
  cover: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: 1000,
    height: '100%',
    width: '100%',
    backgroundColor: '#e2f6ff'
  }
});
